"use strict";

var _regeneratorRuntime = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var immutable_1 = require("immutable");

var index_1 = require("./index");
/**
 * https://nodejs.org/ru/docs/guides/dont-block-the-event-loop/#complex-calculations-without-blocking-the-event-loop
 * @author VRu
 */

/**
 * Maps provided array with mapper function.
 * This function does not block event loop.
 * @param source the array to map
 * @param mapper mapper function
 */


function asyncArrayMap(source, mapper) {
  function map(result, index, resolve, reject) {
    var item = source[index];

    if (index_1.Utils.isValueMissing(item)) {
      reject(new Error("Wrong index ".concat(index, ". Source length is ").concat(source.length, ".")));
      return;
    }

    try {
      Promise.resolve(mapper(item, index)).then(function (r) {
        return result.push(r);
      }).then(function () {
        if (index === source.length - 1) {
          resolve(result);
        } else {
          // don't block event loop
          if (index % 10 === 0) {
            setImmediate(map.bind(null, result, index + 1, resolve, reject));
          } else {
            map(result, index + 1, resolve, reject);
          }
        }
      }).catch(function (err) {
        return reject(err);
      });
      return;
    } catch (err) {
      reject(err);
      return;
    }
  }

  if (source.length === 0) {
    return Promise.resolve([]);
  }

  return new Promise(function (resolve, reject) {
    return map([], 0, resolve, reject);
  });
}

exports.asyncArrayMap = asyncArrayMap;
/**
 * Maps provided list with mapper function.
 * This function does not block event loop.
 * @param source the list to map
 * @param mapper mapper function
 */

function asyncListMap(_x, _x2) {
  return _asyncListMap.apply(this, arguments);
}

function _asyncListMap() {
  _asyncListMap = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(source, mapper) {
    var result;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return asyncArrayMap(source.toArray(), mapper);

          case 2:
            result = _context.sent;
            return _context.abrupt("return", immutable_1.List(result));

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _asyncListMap.apply(this, arguments);
}

exports.asyncListMap = asyncListMap;
/**
 * Reduce provided array with reduce function.
 * This function does not block event loop.
 * @param source the array to reduce
 * @param reducer reduce function
 */

function asyncArrayReduce(source, reducer, initial) {
  function reduce(reduction, index, resolve, reject) {
    var item = source[index];

    if (index_1.Utils.isValueMissing(item)) {
      reject(new Error("Wrong index ".concat(index, ". Source length is ").concat(source.length, ".")));
      return;
    }

    try {
      Promise.resolve(reducer(reduction, item)).then(function (updated) {
        if (index === source.length - 1) {
          resolve(updated);
        } else {
          // don't block event loop
          if (index % 10 === 0) {
            setImmediate(reduce.bind(null, updated, index + 1, resolve, reject));
          } else {
            reduce(updated, index + 1, resolve, reject);
          }
        }
      }).catch(function (err) {
        return reject(err);
      });
      return;
    } catch (err) {
      reject(err);
      return;
    }
  }

  if (source.length === 0) {
    return Promise.resolve(initial);
  }

  return new Promise(function (resolve, reject) {
    return reduce(initial, 0, resolve, reject);
  });
}

exports.asyncArrayReduce = asyncArrayReduce;
/**
 * Reduce provided list with reduce function.
 * This function does not block event loop.
 * @param source the list to reduce
 * @param reducer reduce function
 */

function asyncListReduce(source, reducer, initial) {
  return asyncArrayReduce(source.toArray(), reducer, initial);
}

exports.asyncListReduce = asyncListReduce;
/**
 * Run callback for each item of provided array.
 * This function does not block event loop.
 * @param source the array
 * @param callback callback function
 */

function asyncArrayForEach(source, callback) {
  function forEach(index, resolve, reject) {
    var item = source[index];

    if (index_1.Utils.isValueMissing(item)) {
      reject(new Error("Wrong index ".concat(index, ". Source length is ").concat(source.length, ".")));
      return;
    }

    try {
      Promise.resolve(callback(item)).then(function () {
        if (index === source.length - 1) {
          resolve();
        } else {
          // don't block event loop
          if (index % 10 === 0) {
            setImmediate(forEach.bind(null, index + 1, resolve, reject));
          } else {
            forEach(index + 1, resolve, reject);
          }
        }
      }).catch(function (err) {
        return reject(err);
      });
      return;
    } catch (err) {
      reject(err);
      return;
    }
  }

  if (source.length === 0) {
    return Promise.resolve();
  }

  return new Promise(function (resolve, reject) {
    return forEach(0, resolve, reject);
  });
}

exports.asyncArrayForEach = asyncArrayForEach;
/**
 * Run callback for each item of provided list.
 * This function does not block event loop.
 * @param source the list
 * @param callback callback function
 */

function asyncListForEach(source, callback) {
  return asyncArrayForEach(source.toArray(), callback);
}

exports.asyncListForEach = asyncListForEach;